
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/dummy.js';
            vueApps['app/dummy.js'] = App0;
        

            import App1 from './app/unit.js';
            vueApps['app/unit.js'] = App1;
        

            import App2 from './app/UnitsOfTheDay.js';
            vueApps['app/UnitsOfTheDay.js'] = App2;
        

            import App3 from './app/search.js';
            vueApps['app/search.js'] = App3;
        

            import App4 from './app/navbar.js';
            vueApps['app/navbar.js'] = App4;
        

            import App5 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App5;
        

            import App6 from './app/facilityunits.js';
            vueApps['app/facilityunits.js'] = App6;
        

            import App7 from './app/region.js';
            vueApps['app/region.js'] = App7;
        

            import App8 from './app/LastViewedUnits.js';
            vueApps['app/LastViewedUnits.js'] = App8;
        

            import App9 from './index-action-modal.js';
            vueApps['index-action-modal.js'] = App9;
        

            import App10 from './app/searchmueritz.js';
            vueApps['app/searchmueritz.js'] = App10;
        

            import App11 from './app/searchostsee.js';
            vueApps['app/searchostsee.js'] = App11;
        

            import App12 from './app/searchmithund.js';
            vueApps['app/searchmithund.js'] = App12;
        

            import App13 from './app/searchyoga.js';
            vueApps['app/searchyoga.js'] = App13;
        

            import App14 from './app/searchkrakow.js';
            vueApps['app/searchkrakow.js'] = App14;
        

            import App15 from './app/searchfuhlendorf.js';
            vueApps['app/searchfuhlendorf.js'] = App15;
        

            import App16 from './app/searchmalchow.js';
            vueApps['app/searchmalchow.js'] = App16;
        

            import App17 from './app/searchmitwasserblick.js';
            vueApps['app/searchmitwasserblick.js'] = App17;
        

            import App18 from './app/searchzingst.js';
            vueApps['app/searchzingst.js'] = App18;
        

            import App19 from './app/searchwustrow.js';
            vueApps['app/searchwustrow.js'] = App19;
        

            import App20 from './app/searchfischland.js';
            vueApps['app/searchfischland.js'] = App20;
        

            import App21 from './app/newsletter.js';
            vueApps['app/newsletter.js'] = App21;
        

            import App22 from './app/searchfurfamilien.js';
            vueApps['app/searchfurfamilien.js'] = App22;
        

            import App23 from './app/searchsauna.js';
            vueApps['app/searchsauna.js'] = App23;
        

        
                import Comp24 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp24);
            

                import Comp25 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp25);
            

                import Comp26 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp26);
            

                import Comp27 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp27);
            

                import Comp28 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp28);
            

                import Comp29 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp29);
            

                import Comp30 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp30);
            

                import Comp31 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp31);
            

                import Comp32 from './comp/childrenage.vue';
                Vue.component('childrenage',Comp32);
            

                import Comp33 from './comp/Voucher-Unit.vue';
                Vue.component('voffice-voucher-unit',Comp33);
            

                import Comp34 from './videoIframe.vue';
                Vue.component('video-iframe',Comp34);
            

                import Comp35 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp35);
            

                import Comp36 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp36);
            

                import Comp37 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp37);
            

                import Comp38 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp38);
            

                import Comp39 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp39);
            

                import Comp40 from './comp/NewsletterSubsription.js';
                Vue.component('voffice-newsletter-subscription',Comp40);
            

                import Comp41 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp41);
            

                import Comp42 from './comp/Voucher-Search.vue';
                Vue.component('voffice-voucher-search',Comp42);
            

                import Comp43 from './comp/seasonprices.vue';
                Vue.component('seasonprices',Comp43);
            

                import Comp44 from './comp/ImgFallback2.vue';
                Vue.component('img-fallback2',Comp44);
            

                import Comp45 from './imageCarousel.vue';
                Vue.component('img-carousel',Comp45);
            

                import Comp46 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp46);
            

                import Comp47 from './teamMember.vue';
                Vue.component('voffice-team-member',Comp47);
            

                import Comp48 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp48);
            

                import Comp49 from './offershelp.vue';
                Vue.component('offer-help',Comp49);
            

                import Comp50 from './comp/feedback-carousel.vue';
                Vue.component('feedback-carousel',Comp50);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    